import { Button, Dialog, DialogActions, Stack } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import InherentRiskMethodologyContent from './InherentRiskMethodologyContent'

type RiskScreeningInfoDialogProps = {
  open: boolean
  closeDialog: () => void
}

const RiskScreeningInfoDialog: React.FC<RiskScreeningInfoDialogProps> = ({ open, closeDialog }) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog open={open} onClose={closeDialog} maxWidth="md" fullWidth scroll="body">
      <Stack p={6} pb={2}>
        <InherentRiskMethodologyContent />
      </Stack>

      <DialogActions sx={{ px: 6, pb: 4 }}>
        <Button onClick={closeDialog}>{formatMessage({ id: 'general.close' })}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default RiskScreeningInfoDialog
